export enum SubsidiaryCountry {
  FRANCE = "87",
  LUXEMBOURG = "91",
  NETHERLANDS = "92",
  BELGIUM = "94",
  GERMANY = "95",
}
